import { Component, Input } from '@angular/core';

// components
import { PublicFooter } from '../components/public-footer/public-footer';
import { PublicHeader } from '../components/public-header/public-header';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public.layout.html',
  styleUrls: ['./public.layout.scss'],
  standalone: true,
  imports: [
    PublicFooter,
    PublicHeader,
  ],
})
export class PublicLayout {

  @Input() displayHeader: boolean = true;
  @Input() displayFooter: boolean = true;

}